/* @flow */
import Store from 'lib/Store';

import { ActionTypes } from '../constants/MessageComposerConstants';

class MessageComposerStore extends Store {
  getInitialState() {
    return {
      composerStates: {},
    };
  }

  getComposerStates(chatId: string) {
    return this.state.composerStates[chatId];
  }

  setComposerStates(chatId: string, state: Object) {
    this.state.composerStates[chatId] = state;
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case ActionTypes.SAVE_STATE:
        this.setComposerStates(action.chatId, action.state);
        this.emitChange();
        break;
      default:
        break;
    }
  }
}

export default new MessageComposerStore();



// WEBPACK FOOTER //
// ./src/chat/stores/MessageComposerStore.js